export default __webpack_public_path__ + "images/Imagen 2.99dbf5cc8f114437b5ff43d053596b8f.png";